import { connect } from 'react-redux';
import Progress from '../../components/progress/Progress';

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Progress);
